var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"item-tour"},[_c('ul',[_c('li',[_c('div',{staticClass:"has-icon add-icon add-tour d-flex justify-content-between"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.dayDetail.descriptionTitle))])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d1863d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/itinerario/ItemMinitourDay.vue
// module id = null
// module chunks = 